import styles from './NonArmstrongHeader.css';
import { ApiPathConfig } from '../../../api/api-path-config';
import { FormattedMessage } from 'react-intl';
import { Button } from '@xingternal/button';
import React from 'react';

interface DownloadPdfButtonProps {
  slug: string;
}

export const DownloadPdfButton: React.FC<DownloadPdfButtonProps> = ({
  slug,
}) => (
  <Button
    className={styles.downloadPdfButton}
    target="_blank"
    href={ApiPathConfig.publicTermsShowPdf(slug)}
    size="medium"
    variant="primary"
  >
    <FormattedMessage id="LEGAL_PAGES_DOWNLOAD_PDF" />
  </Button>
);
